import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { GiaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/GiaContributionInstruction";
import { InstructionIsAdHocNoChangeClient } from "../../../../../../Wrap/Api/Apply/InstructionIsAdHocNoChange";
import { IsaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/IsaContributionInstruction";
import { PensionContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionContributionInstruction";
import { WhatIfToolInstructionClient } from "../../../../../../Wrap/Api/Apply/WhatIfToolInstruction";
import { ProcessType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { NoChangeToolDisaptcher } from "../Store/Variable";

export class NoChangeAction {
    public static getInstruction(
        id: string,
        hierarchyId: string,
        subAccountHierarchyId: string,
        clientId: number,
        productType: SubAccountType
    ): void {
        if (SubAccountTypeHelper.isPP(productType)) {
            const giaContributionInstruction = new GiaContributionInstructionClient();
            this.getOrCreateInstruction(giaContributionInstruction, id, hierarchyId, subAccountHierarchyId, clientId);
        } else if (SubAccountTypeHelper.isIsa(productType)) {
            const isaContributionInstruction = new IsaContributionInstructionClient();
            this.getOrCreateInstruction(isaContributionInstruction, id, hierarchyId, subAccountHierarchyId, clientId);
        } else if (SubAccountTypeHelper.isOnPlatformPension(productType))
        {
            const pensionContributionInstruction = new PensionContributionInstructionClient();
            this.getOrCreateInstruction(pensionContributionInstruction, id, hierarchyId, subAccountHierarchyId, clientId);
        }
    }

    public static submitInstruction(instructionId: string, callback) {
        const client = new WhatIfToolInstructionClient();
        const promise = client.put(instructionId);
        promise.onSuccess((data) => {
            callback(data);
        });
    }

    private static getOrCreateInstruction(
        client: IsaContributionInstructionClient | GiaContributionInstructionClient | PensionContributionInstructionClient,
        id,
        hierarchyId,
        subAccountHierarchyId,
        clientId
    ) {
        if (!CommonHelper.isNullOrEmpty(id)) {
            // Have instructionId
            const promise = client.get(id, clientId, "", null);
            this.updateNoChangeInstructionStore(promise);
        } else {
            // Create new instruction
            const promise = client.post(subAccountHierarchyId, hierarchyId, ProcessType.NoChangeTool);
            promise.onSuccess((result) => {
                const instructionId = result.Result;
                const model = client.get(instructionId, clientId, "", null);
                this.updateNoChangeInstructionStore(model);
            });

            promise.onError((err) => {
                NoChangeToolDisaptcher.dispatch({
                    actionType: ActionType.Error,
                    payload: err,
                });
            });
        }
    }

    private static updateNoChangeInstructionStore(promise: any, callback?: (data) => void) {
        promise.onSuccess((result) => {
            NoChangeToolDisaptcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (callback) {callback([]);}
        });

        promise.onError((err) => {
            NoChangeToolDisaptcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getPrepopulateData(subAccountHierarchyId: string, headHierarchyId: string, callback) {
        const client = new WhatIfToolInstructionClient();
        const promise = client.get(subAccountHierarchyId, headHierarchyId, null);
        promise.onSuccess((data) => {
            callback(data);
        });
    }
    public static updateInstructionIsAdHocNoChange(instructionId: number, isAdHocNoChange = true) {
        const client = new InstructionIsAdHocNoChangeClient();
        const promise = client.put(instructionId, isAdHocNoChange);
        promise.onSuccess(() => {});
    }
}
